import React from 'react';
import {
  Home,
  Bot,
  Briefcase,
  Users,
  Wrench,
  BarChart3,
  GraduationCap,
  HelpCircle,
  ClipboardList,
  ShieldCheck,
  ChevronDown,
  ChevronRight,
} from 'lucide-react';

const menuItems = [
  {
    id: 'home',
    label: 'Inicio',
    icon: Home,
    path: '/',
  },
  {
    id: 'ai-tools',
    label: 'Herramientas IA',
    icon: Bot,
    path: '/herramientas-ia',
  },
  {
    id: 'crm',
    label: 'CRM y Ventas',
    icon: Briefcase,
    path: '/crm-ventas',
  },
  {
    id: 'hr',
    label: 'Recursos Humanos',
    icon: Users,
    path: '/recursos-humanos',
    children: [
      {
        id: 'hr-overview',
        label: 'Resumen',
        path: '/recursos-humanos',
      },
      {
        id: 'availability',
        label: 'Disponibilidad',
        path: '/recursos-humanos/disponibilidad',
      },
    ],
  },
  {
    id: 'tools',
    label: 'Herramientas Corporativas',
    icon: Wrench,
    path: '/herramientas-corporativas',
  },
  {
    id: 'analytics',
    label: 'Analytics',
    icon: BarChart3,
    path: '/analytics',
  },
  {
    id: 'training',
    label: 'Formación y Documentación',
    icon: GraduationCap,
    path: '/formacion',
  },
  {
    id: 'support',
    label: 'Soporte Técnico',
    icon: HelpCircle,
    path: '/soporte',
  },
  {
    id: 'surveys',
    label: 'Encuestas y Feedback',
    icon: ClipboardList,
    path: '/encuestas',
  },
];

const Sidebar = ({ currentPath, onNavigate, isCollapsed, onToggleCollapse, roles }) => {
  const [expandedItems, setExpandedItems] = React.useState(() =>
    menuItems
      .filter((item) => item.children && currentPath.startsWith(item.path))
      .map((item) => item.id)
  );
  const visibleMenuItems = roles?.admin
    ? [
        ...menuItems,
        {
          id: 'admin',
          label: 'Administración',
          icon: ShieldCheck,
          path: '/administracion',
        },
      ]
    : menuItems;

  const toggleExpanded = (id) => {
    setExpandedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <aside
      className={`fixed left-0 top-16 h-[calc(100vh-64px)] bg-white shadow-sidebar z-40 transition-all duration-300 ${
        isCollapsed ? 'w-20' : 'w-sidebar'
      }`}
    >
      <nav className="flex flex-col h-full py-4">
        <div className="flex-1 overflow-y-auto px-3 space-y-1">
          {visibleMenuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPath === item.path ||
              (item.children && currentPath.startsWith(`${item.path}/`));
            const hasChildren = item.children && item.children.length > 0;
            const isExpanded = expandedItems.includes(item.id);

            return (
              <div key={item.id}>
                <button
                  onClick={() => {
                    if (hasChildren && !isCollapsed) {
                      toggleExpanded(item.id);
                    } else {
                      onNavigate(item.path);
                    }
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-150 ${
                    isActive
                      ? 'bg-primary-lighter/50 text-primary font-medium'
                      : 'text-text-secondary hover:bg-primary-lighter/30 hover:text-primary'
                  }`}
                  title={isCollapsed ? item.label : undefined}
                >
                  <Icon size={20} className="flex-shrink-0" />
                  {!isCollapsed && (
                    <>
                      <span className="flex-1 text-left text-sm">{item.label}</span>
                      {hasChildren && (
                        <span className="text-text-tertiary">
                          {isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                        </span>
                      )}
                    </>
                  )}
                </button>

                {/* Submenu */}
                {hasChildren && isExpanded && !isCollapsed && (
                  <div className="ml-7 mt-1 space-y-1">
                    {item.children.map((child) => (
                      <button
                        key={child.id}
                        onClick={() => onNavigate(child.path)}
                        className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
                          currentPath === child.path
                            ? 'text-primary font-medium'
                            : 'text-text-secondary hover:text-primary'
                        }`}
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-50" />
                        {child.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Collapse Toggle */}
        <div className="px-3 pt-4 border-t border-border-light">
          <button
            onClick={onToggleCollapse}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 text-text-tertiary hover:text-text-secondary transition-colors"
          >
            {isCollapsed ? (
              <ChevronRight size={20} />
            ) : (
              <>
                <ChevronDown size={20} className="rotate-90" />
                <span className="text-sm">Colapsar menú</span>
              </>
            )}
          </button>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;


